import React from 'react';
import '../css/Footer.css';
import axiosInstance from './config/axiosConfig';

export default function Footer() {
  return (
    <footer className="footer">
      Secretaría de Seguridad Alimentaria y Nutricional
    </footer>
  );
}